import getCoverArtUrl from './getCoverArtUrl';
import getShortcutBreadcrumbs from './getShortcutBreadcrumbs';

/* eslint-disable camelcase */
export default ({
  is_active,
  name,
  caption,
  is_locale_master,
  video,
  video_file_name,
  cover_art,
  author,
  published_at,
  code,
  credit_units,
  locale,
  shortcuts,
  community_enabled,
  customFields,
  exclude_from_search,
  summary,
  tags,
  seo_title,
  seo_description,
  url_slug,
  robots_meta_tags,
  topics,
}) => ({
  general: {
    is_active,
    name,
    caption,
    is_locale_master,
  },
  video: {
    video,
    video_file_name,
  },
  display: {
    cover_art: getCoverArtUrl(cover_art),
  },
  additional_details: {
    author,
    published_at,
    code,
    credit_units,
    locale,
  },
  associations: {
    shortcuts: getShortcutBreadcrumbs(shortcuts),
  },
  social: {
    community_enabled,
  },
  custom_fields: {
    ...customFields,
  },
  catalog: {
    exclude_from_search,
    summary,
  },
  tagging: {
    tags,
  },
  seo_properties: {
    seo_title,
    seo_description,
    url_slug,
    robots_meta_tags,
  },
  topics,
});
